import { Dialog, Transition } from '@headlessui/react'
import { Dispatch, Fragment, SetStateAction } from 'react'
import './style.css'

type Props = {
  openChat: boolean
  closeModal: () => void
  setOpenChat: Dispatch<SetStateAction<boolean>>
  enabled: boolean
}

/**
 * Chat is temporarily disabled. The entry points that used to open this modal have been removed;
 * this component now only renders an "unavailable" notice as a backstop in case it is still reached
 * (e.g. a lingering link or state). The Stream connection and channel UI are intentionally gone.
 */
export const ChatModal = ({ openChat, closeModal }: Props) => {
  return (
    <Transition appear show={openChat} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center p-0 sm:p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-11/12 max-w-md transform overflow-hidden rounded-2xl bg-white p-8 text-center align-middle shadow-xl transition-all">
                <h3 className="text-lg font-semibold text-navy-900">Chat is temporarily unavailable</h3>
                <p className="mt-2 text-sm text-gray-500">
                  Messaging is turned off right now. Please check back later.
                </p>
                <button
                  className="mt-6 inline-flex items-center justify-center rounded-full bg-navy-900 px-6 h-9 text-sm font-semibold text-white hover:opacity-90"
                  onClick={closeModal}
                >
                  Close
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
